import { useNavigate, useParams } from "@vixi/router";
import { useCallback } from "react";
import { useGoBack } from "@vixi/ui";

export const useEditCourseGoBack = () => {
  const navigate = useNavigate();
  const { courseId } = useParams({
    strict: false,
  });

  const goBack = useCallback(() => {
    navigate({
      to: "/courses/$courseId",
      params: { courseId: courseId || "" },
    });
  }, []);

  useGoBack(goBack);
};
